import { render, staticRenderFns } from "./EncounterDashboard.vue?vue&type=template&id=69800665&scoped=true&"
import script from "./EncounterDashboard.vue?vue&type=script&lang=js&"
export * from "./EncounterDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69800665",
  null
  
)

export default component.exports